import React from "react";
import { useParams, Link } from "react-router-dom";
import profileCardImage from "../assets/Kolkata_RTO.jpg";

const verifyPages = {
  "MM-RB-001": {
    profileName: "BISWAJIT BANERJEE",
    designation: "DIRECTOR & CEO",
    id: "MM-RB-001",
    bloodGroup: "O+",
    status: "Active",
    contact: "+91-9477897491",
    email: "INFO@RTOBHARAT.COM",
    website: "WWW.RTOBHARAT.COM",
    propertyText: "THIS CARD REMAINS THE PROPERTY OF MOTOMITRA (OPC) PRIVATE LIMITED.",
    qrText: "SCAN TO ACCESS RTO BHARAT",
    qrData: "https://rtobharat.com/verify/MM-RB-001"
  },
  "MM-RB-002": {
    profileName: "PIJUSH KANTI BANERJEE",
    designation: "MANAGING DIRECTOR & PRESIDENT",
    id: "MM-RB-002",
    bloodGroup: "A+",
    status: "Active",
    contact: "+91-9477897491",
    email: "INFO@RTOBHARAT.COM",
    website: "WWW.RTOBHARAT.COM",
    propertyText: "THIS CARD REMAINS THE PROPERTY OF MOTOMITRA (OPC) PRIVATE LIMITED.",
    qrText: "SCAN TO ACCESS RTO BHARAT",
    qrData: "https://rtobharat.com/verify/MM-RB-002"
  }
};

const normalizeVerifyCode = (code) => {
  if (typeof code !== "string") return "";
  return code.trim().toUpperCase();
};

const Verify = () => {
  const { code } = useParams();
  const normalizedCode = normalizeVerifyCode(code);
  const page = verifyPages[normalizedCode];

  if (!page) {
    return (
      <div className="bg-slate-950 text-white min-h-screen p-6 flex items-center justify-center">
        <div className="max-w-3xl w-full bg-slate-900 rounded-[32px] shadow-2xl border border-slate-800 p-10">
          <h1 className="text-4xl font-bold mb-4">Verification page not found</h1>
          <p className="text-slate-300 mb-6">
            The verification code <strong>{code || "Unknown"}</strong> is not recognized.
          </p>
          <div className="flex flex-wrap gap-4">
            <Link
              to="/"
              className="inline-flex items-center justify-center rounded-full bg-orange-500 px-6 py-3 text-sm font-semibold text-slate-950 hover:bg-orange-400 transition"
            >
              Return to Home
            </Link>
            <Link
              to="/contact"
              className="inline-flex items-center justify-center rounded-full border border-slate-700 bg-slate-950 px-6 py-3 text-sm font-semibold text-white hover:border-orange-500 transition"
            >
              Contact Support
            </Link>
          </div>
        </div>
      </div>
    );
  }

  const qrUrl = `https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=${encodeURIComponent(page.qrData)}`;

  return (
    <div className="bg-slate-950 min-h-screen py-10 px-4 text-white">
      <div className="mx-auto grid max-w-6xl gap-6 lg:grid-cols-[0.9fr_0.8fr]">
        <div className="rounded-[36px] bg-slate-950 border border-orange-500 shadow-2xl overflow-hidden">
          <div className="relative overflow-hidden bg-slate-900 p-6">
            <div className="flex items-center justify-between mb-6">
              <div>
                <p className="text-white/60 uppercase tracking-[0.35em] text-xs">RTO Bharat</p>
              </div>
              <div className="flex h-14 w-14 items-center justify-center rounded-3xl bg-orange-500 text-slate-950 font-bold">
                R
               </div>
            </div>
            <div className="rounded-[32px] border border-orange-500 overflow-hidden">
              <img src={profileCardImage} alt={page.profileName} className="h-[380px] w-full object-cover" />
            </div>
          </div>
          <div className="bg-slate-950 p-6">
            <div className="mb-6">
              <h2 className="text-3xl font-bold tracking-tight">{page.profileName}</h2>
              <p className="text-sm uppercase text-orange-300 tracking-[0.3em] mt-2">{page.designation}</p>
            </div>
            <div className="grid gap-4 text-sm text-slate-300">
              <div className="rounded-3xl bg-slate-900 p-5 border border-slate-800">
                <p className="text-[0.75rem] uppercase tracking-[0.3em] text-slate-500">ID No</p>
                <p className="mt-2 text-lg font-semibold text-white">{page.id}</p>
              </div>
              <div className="rounded-3xl bg-slate-900 p-5 border border-slate-800">
                <p className="text-[0.75rem] uppercase tracking-[0.3em] text-slate-500">Blood Group</p>
                <p className="mt-2 text-lg font-semibold text-white">{page.bloodGroup}</p>
              </div>
              <div className="rounded-3xl bg-slate-900 p-5 border border-slate-800">
                <p className="text-[0.75rem] uppercase tracking-[0.3em] text-slate-500">Status</p>
                <p className="mt-2 text-lg font-semibold text-white">{page.status}</p>
              </div>
            </div>
          </div>
        </div>

        <div className="space-y-6">
          <div className="rounded-[36px] bg-slate-800 border border-slate-700 p-8 shadow-xl">
            <p className="text-xs uppercase tracking-[0.35em] text-slate-500 mb-6">RTO Bharat</p>
            <p className="text-sm text-slate-400 leading-7">{page.propertyText}</p>
            <div className="mt-8 space-y-4">
              <div className="rounded-3xl bg-slate-950 border border-slate-700 p-5">
                <p className="text-[0.7rem] uppercase tracking-[0.3em] text-slate-500">Contact</p>
                <p className="mt-3 text-lg font-semibold text-white">{page.contact}</p>
              </div>
              <div className="rounded-3xl bg-slate-950 border border-slate-700 p-5">
                <p className="text-[0.7rem] uppercase tracking-[0.3em] text-slate-500">Email</p>
                <p className="mt-3 text-lg font-semibold text-white">{page.email}</p>
              </div>
              <div className="rounded-3xl bg-slate-950 border border-slate-700 p-5">
                <p className="text-[0.7rem] uppercase tracking-[0.3em] text-slate-500">Website</p>
                <p className="mt-3 text-lg font-semibold text-white">{page.website}</p>
              </div>
            </div>
          </div>

          <div className="rounded-[36px] bg-slate-900 border border-slate-800 p-8 shadow-xl">
            <div className="flex items-center justify-between mb-6">
              <div>
                <p className="text-xs uppercase tracking-[0.35em] text-orange-400">{page.qrText}</p>
              </div>
            </div>
            <div className="rounded-3xl bg-white p-4">
              <img src={qrUrl} alt="QR code" className="mx-auto block h-72 w-72 object-contain" />
            </div>
            <div className="mt-6 flex flex-col gap-3 sm:flex-row">
              <Link
                to="/"
                className="inline-flex w-full items-center justify-center rounded-full bg-orange-500 px-6 py-3 text-sm font-semibold text-slate-950 hover:bg-orange-400 transition"
              >
                Go to Home
              </Link>
              <Link
                to="/contact"
                className="inline-flex w-full items-center justify-center rounded-full border border-slate-700 bg-slate-950 px-6 py-3 text-sm font-semibold text-white hover:border-orange-500 transition"
              >
                Contact Support
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Verify;
